module.exports = __webpack_public_path__ + "64de503f539c692c31b3ece214a48d1b.svg";